import { c as _c } from "react/compiler-runtime";
import { Button } from '@sbt-web/ui';
import { extractUtmFromLocation, getAdId } from '@sbt-web/utils';
import { trackIncreaseVisibilityClick } from './tracking';
import styles from './index.module.scss';
type IncreaseVisibilityButtonProps = {
  isMobile: boolean;
  adUrn: string;
};
export const getPromoteURL = (adUrn: string): string => {
  const queryParams = extractUtmFromLocation();
  queryParams.append('entry_point', 'ADDETAIL_PROMOTE');
  return new URL(`${process.env.NEXT_PUBLIC_AREARISERVATA_BASE_URL}/annunci/promuovi/${adUrn}?${queryParams.toString()}`).toString();
};
export const IncreaseVisibilityButton = t0 => {
  const $ = _c(6);
  const {
    isMobile,
    adUrn
  } = t0;
  let t1;
  if ($[0] !== adUrn) {
    t1 = async () => {
      const adID = getAdId(adUrn);
      if (adID) {
        trackIncreaseVisibilityClick(adID);
      }
      window.location.assign(getPromoteURL(adUrn));
    };
    $[0] = adUrn;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [styles.increaseVisibilityButton];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = isMobile ? "large" : "medium";
  let t4;
  if ($[3] !== handleClick || $[4] !== t3) {
    t4 = <Button onClick={handleClick} classes={t2} size={t3}>Aumenta visibilità</Button>;
    $[3] = handleClick;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};